module.exports = __webpack_public_path__ + "media/9.bf82ba74.mp3";